export default __webpack_public_path__ + "static/media/project-one-img.687c7ba1.jpg";